import { ref, shallowRef } from "vue";

import { defineStore } from "pinia";

import type {
  CallLog,
  CommunicationModalType,
} from "@/models/communicationLogs";

const useQuickActionsStore = defineStore("quick-actions", () => {
  const isVisible = ref(false);
  const communicationModalType = ref<CommunicationModalType | null>(null);
  const isCallFormOpen = ref(false);
  const callDialog = shallowRef<CallLog | null>(null);

  const openCommunicationModal = ({
    type,
  }: {
    type: CommunicationModalType;
  }) => {
    if (communicationModalType.value) {
      return;
    }
    isCallFormOpen.value = false;
    communicationModalType.value = type;
  };

  const closeCommunicationModal = () => {
    communicationModalType.value = null;
  };

  const openCallForm = () => {
    communicationModalType.value = null;
    isCallFormOpen.value = true;
  };

  const closeCallForm = () => {
    isCallFormOpen.value = false;
  };

  const openCallDialog = ({ log }: { log: CallLog }) => {
    callDialog.value = log;
  };

  const closeCallDialog = () => {
    callDialog.value = null;
  };

  return {
    isVisible,
    communicationModalType,
    isCallFormOpen,
    callDialog,
    openCommunicationModal,
    closeCommunicationModal,
    openCallForm,
    closeCallForm,
    openCallDialog,
    closeCallDialog,
  };
});

export default useQuickActionsStore;
